<template>
  <div class="header_warp">
    <div class="screen-outer">
      <div class="header_main" :class="isScroll?'':'header_main_active'">
        <div class="screen-outer">
          <div class="flex-sb-c header_box">
            <div class="flex-sb-c left">
              <div class="logo_box"></div>
              <!-- <el-image style="width: 130px; height: 34px" :src="isScroll?require('../../assets/image/logo2.png'):require('../../assets/image/logo.png')"></el-image> -->
              <div class="flex-sb-c nav_box">
                <div class="nav_item cspt" :class="currentTab==0?'active':''" @click="gotoIndex()">首页</div>
                <div class="nav_item cspt" :class="currentTab==1?'active':''" @click="gotoCategory()">课程中心</div>
                <div class="nav_item cspt" :class="currentTab==2?'active':''" @click="gotoArticle()">热点阅读</div>
                <div class="nav_item cspt" :class="currentTab==3?'active':''" @click="gotoActivity()">信息发布</div>
                <div class="nav_item cspt" v-show="showConsultMenu" @click="openConsult()">在线咨询</div>
              </div>
            </div>
            <div class="flex-sb-c right">
              <div class="input_box">
                <el-input placeholder="请输入关键词" v-model="inputValue" class="input-with-select" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="gotoSearch()"></el-button>
                </el-input>
              </div>
              <div class="login_box" v-if="isLoginStatus == null || isLoginStatus==0">
                <div class="flex-sb-c">
                  <div class="login_img"></div>
                  <!-- <el-image style="width: 18px; height: 18px;flex-shrink: 0;margin-left: 58px;" :src="require('../../assets/image/login2.png')"></el-image> -->
                  <div class="login_text cspt" @click.stop="openLogin()">登录/注册</div>
                </div>
              </div>
              <div class="info_box" v-else>
                <div class="info_left">
                  <div class="name" v-if="user != null">{{ user.userName }}</div>
                  <div class="vip_end">{{ vipEndDay }}</div>
                </div>
                <el-image style="width: 40px; height: 40px;border-radius: 50%" :src="remoteImageUrl"></el-image>
                <div class="handle_box">
                  <div class="top">
                    <el-image style="width: 44px; height: 44px;flex-shrink: 0;border-radius: 50%"
                              :src="remoteImageUrl"></el-image>
                    <div class="name_text" v-if="user != null">{{ user.userName }}</div>
                  </div>
                  <div class="bottom img_bottom cspt" @click="gotoPerson()" v-if="isIpLogin!=1">
                    <div class="bottom_img"></div>
                    <!-- <el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="require('../../assets/image/center.jpg')"></el-image> -->
                    <div>个人中心</div>
                  </div>
                  <div class="bottom out_bottom cspt" @click="logout()">
                    <div class="bottom_img"></div>
                    <!-- <el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="require('../../assets/image/login_out.jpg')"></el-image> -->
                    <div v-if="isIpLogin!=1">退出登录</div>
                    <div v-else="isIpLogin==1">切换个人登录</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :showLogin="showLogin" :close="closeLogin"></Login>

    <Consult :showConsult="showConsult" :user="user" :feedBacksC="feedBacksC" :close="closeConsult"></Consult>
  </div>
</template>

<script>
import Login from "@/components/dialog/login.vue"
import Consult from "@/components/dialog/consult.vue"
import store from "@/store";
import {getImageUrl} from "@/api/personal";
import {getDateDifference} from "@/utils/common";
import {Message} from "element-ui";
import {logoutremote} from "@/api/login";
import {setItemWithExpiry, getItemWithExpiry} from "@/store/localstoragewithexpire";
import request from "@/utils/request";

export default {
  components: {
    Login,
    Consult
  },
  props: {
    currentTab: Number,
    isScroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      inputValue: null,
      select: "0",
      isLogin: false,
      cartTotal: 0,
      language: 'English',
      cartListData: [],
      langData: 'en',
      showLogin: false,
      showConsult: false,
      isLoginStatus: 0,
      user: null,
      remoteImageUrl: '',
      showConsultMenu: '',
      vipEndDay: 0,
      isIpLogin: 0,
      feedBacksC: [],
      isPersonLogin: 0,
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // this.isIpLogin = localStorage.getItem("iploginsucc");
      // this.isLoginStatus = localStorage.getItem("isLogin");
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.isIpLogin = getItemWithExpiry("iploginsucc");
      this.isLoginStatus = getItemWithExpiry("isLogin");
      this.isPersonLogin = getItemWithExpiry("isPersonLogin");
      //this.user = JSON.parse(getItemWithExpiry(("user")));
      if (this.user != null) {
        let enddiff = getDateDifference(new Date(this.user.vipEndTime));
        setItemWithExpiry('vipenddays', enddiff, 10);
        if (enddiff > 0) {
          this.vipEndDay = 'VIP还有' + enddiff + '天到期';
        } else {
          this.vipEndDay = 'VIP已到期';
        }
        let roles = this.user.roles;
        if (roles != null && !(typeof roles === "undefined")) {
          for (let i = 0; i < roles.length; i++) {
            let item = roles[i];
            if (item.roleKey == 'showConsultMenu') {
              this.showConsultMenu = true;
              break;
            }
          }
        }
        let data = {
          imageName: this.user.avatar.replace("/profile/avatar", ''),
        }
        getImageUrl('getavatarimage', data).then(res => {
          if (res != null && res != '') {
            this.remoteImageUrl = `data:image/jpeg;base64,${res}`;
          } else {
            this.remoteImageUrl = require('../../assets/image/avatar2.png');
          }
        }).catch(e => {
          this.remoteImageUrl = require('../../assets/image/avatar2.png');
        });
      }
    },
    logout() {
      let data = {
        // iploginsucc: localStorage.getItem("iploginsucc"),
        // uuid: localStorage.getItem("uuid"),
        iploginsucc: getItemWithExpiry("iploginsucc"),
        uuid: getItemWithExpiry("uuid"),
      };

      //if (this.isIpLogin != 1) {
      logoutremote(data).then(res => {
        setItemWithExpiry("isLogin", 0);
        localStorage.removeItem("token");
        localStorage.removeItem("iploginsucc");
        localStorage.removeItem("isPersonLogin");
        localStorage.removeItem("uuid");
        localStorage.removeItem("vipenddays")
        this.showConsult = false;
        sessionStorage.removeItem("user");
        this.showConsultMenu = false;
        this.$router.push('/')
        this.isLoginStatus = 0
      }).catch(error => {
        console.log(error)
      });
      //}

    },
    closeLogin() {
      this.showLogin = false
    },
    closeConsult() {
      this.showConsult = false
    },
    openConsult() {
      //let token = localStorage.getItem("token");
      let token = getItemWithExpiry("token");
      if (token == null || token == '') {
        Message({
          message: '请先登录，然后进行其他操作！',
          type: 'error',
          duration: 2 * 1000
        })
        return;
      }
      this.feedBacksC = [];
      //当用户是非IP地址登录时，加载过往留言信息
      if (this.isPersonLogin == 1 && this.user != null) {
        let data = {
          "userId": this.user.userId,
          "pageSize": 10,
          "feedType": '咨询'
        }
        request({
          url: '/api/index/getfeedback',
          method: 'post',
          params: data
        }).then(res => {
          this.feedBacksC = res.feedbacks;
        })
      }
      this.showConsult = true;
    },
    openLogin() {
      this.showLogin = true
    },
    search() {
      // console.log(this.select)
      this.$router.push('/category?q=' + this.input)
    },
    gotoArticle() {
      this.$router.push('/article')
    },
    gotoCategory() {
      this.$router.push('/category')
    },
    changeLanguage(command) {
      // this.$message('click on item ' + command);
      this.$i18n.locale = command
      //localStorage.setItem('lang', command)
      setItemWithExpiry('lang', command)
      if (command == 'en') {
        this.language = 'English'
      } else {
        this.language = '中文'
      }

      location.reload()
    },
    gotoPerson() {
      this.$router.push('/personal');
    },
    gotoIndex() {
      this.$router.push('/');
    },
    gotoActivity() {
      this.$router.push('/activity');
    },
    gotoOrder() {
      if (this.isLogin) {
        this.$router.push('/order');
      } else {
        this.$router.push('/login');
      }
    },
    gotoMessage() {
      if (this.isLogin) {
        this.$router.push('/personal?page=order')
      } else {
        this.$router.push('/login');
      }
    },
    gotoSearch() {
      if (!this.inputValue) return
      this.$router.push('/category?q=' + this.inputValue)
    },
  }
}
</script>

<style lang="scss" scoped>
.header_warp {
  width: 100%;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

::v-deep .header_main {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background-color: #fff;
  z-index: 100;

  .header_box {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    .left {
      height: 70px;
      margin-right: 108px;

      .logo_box {
        width: 130px;
        height: 34px;
        background: url("../../assets/image/logo2.png") no-repeat center/100%;
      }

      .nav_box {
        margin-left: 40px;

        .nav_item {
          margin-right: 30px;
          font-size: 14px;
          color: #333333;

          &:hover {
            color: #FF7F92;
          }
        }

        .nav_item.active {
          position: relative;
          color: #FF7F92;

          &::after {
            content: "";
            position: absolute;
            top: 22px;
            left: 0;
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #FF7F92;
          }
        }
      }
    }

    .right {
      .input_box {
        background-image: linear-gradient(98deg, rgba(244, 148, 181, 1), rgba(175, 103, 179, 1));
        border-radius: 60px;
        padding: 1px;
        overflow: hidden;

        .el-input-group {
          width: 200px;
          background: #fff;
          color: #f4f4f4;
          border-radius: 20px;
        }

        .el-select .el-input {
          width: 200px;
        }

        .el-input-group__append {
          padding: 0;
          overflow: hidden;
          border: 0;
          background: linear-gradient(90deg, #AF67B3 0%, #F796B6 100%);
          border-radius: 60px 60px 60px 60px;
          font-size: 20px;
        }

        .el-input-group > .el-input__inner {
          border: 0;
          background: none;
          border-radius: 60px 0 0 60px;
          color: #000000;

          &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
            color: #333333;
          }

          &::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #333333;
          }

          &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #333333;
          }

          &::-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #333333;
          }

          &::-ms-input-placeholder { /* Microsoft Edge */
            color: #333333;
          }
        }

        .el-input-group__append .el-select {
          margin: -10px 0;
        }

        .el-input-group__append .el-button {
          margin: -10px 0;
          border: none;
          color: #fff;
          border-radius: 0;
        }
      }

      .login_box {
        .login_img {
          width: 18px;
          height: 18px;
          flex-shrink: 0;
          margin-left: 58px;
          background: url("../../assets/image/login2.png") no-repeat center/100%;
        }

        .login_text {
          flex-shrink: 0;
          font-size: 14px;
          color: #333333;
          margin-left: 4px;
        }
      }

      .info_box {
        display: flex;
        align-items: center;
        margin-left: 12px;
        position: relative;
        height: 70px;

        .info_left {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          margin-right: 4px;

          .name {
            max-width: 78px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #333333;
            margin-bottom: 4px;
          }

          .vip_end {
            flex-shrink: 0;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #ffffff;
            padding: 0 8px;
            background: #EDAD32;
            border-radius: 4px;
          }
        }

        .handle_box {
          display: none;
          position: absolute;
          background: #ffffff;
          border-radius: 10px;
          top: 70px;
          left: -104px;
          width: 222px;
          height: 176px;
          overflow: hidden;

          .top {
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            .name_text {
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 16px;
              font-weight: 700;
              color: #EEB23F;
              margin-left: 10px;
            }
          }

          .bottom {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 56px;

            .bottom_img {
              width: 18px;
              height: 18px;
              margin-right: 6px;
            }
          }

          .img_bottom {
            .bottom_img {
              background: url("../../assets/image/center.jpg") no-repeat center/100%;
            }

            &:hover {
              background: #FF7F92;
              color: #ffffff;

              .bottom_img {
                background: url("../../assets/image/center_active.jpg") no-repeat center/100%;
              }
            }
          }

          .out_bottom {
            .bottom_img {
              background: url("../../assets/image/login_out.jpg") no-repeat center/100%;
            }

            &:hover {
              background: #EA6666;
              color: #ffffff;

              .bottom_img {
                background: url("../../assets/image/login_out_active.jpg") no-repeat center/100%;
              }
            }
          }
        }

        &:hover {
          .handle_box {
            display: block;
          }
        }
      }
    }
  }
}

::v-deep .header_main_active {
  background-color: #00000017;

  .header_box {
    .left {
      .logo_box {
        background: url("../../assets/image/logo.png") no-repeat center/100%;
      }

      .nav_box {
        .nav_item {
          color: #ffffff;

          &:hover {
            color: #FCCE2D;
          }
        }

        .nav_item.active {
          color: #FCCE2D;

          &::after {
            background: #FCCE2D;
          }
        }
      }
    }

    .right {
      .input_box {
        .el-input-group {
          background-image: linear-gradient(90deg, #BA7CB0, #B87AB1);
          color: #f4f4f4;
        }

        .el-input-group__append {
          background: linear-gradient(90deg, #AF67B3 0%, #F796B6 100%);
        }

        .el-input-group > .el-input__inner {
          color: #fff;

          &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
            color: #f4f4f4;
          }

          &::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #f4f4f4;
          }

          &::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #f4f4f4;
          }

          &::-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #f4f4f4;
          }

          &::-ms-input-placeholder { /* Microsoft Edge */
            color: #f4f4f4;
          }
        }

        .el-input-group__append .el-button {
          color: #fff;
        }
      }

      .login_box {
        .login_img {
          background: url("../../assets/image/login.png") no-repeat center/100%;
        }

        .login_text {
          color: #ffffff;
        }
      }

      .info_box {
        .info_left {
          .name {
            color: #ffffff;
          }
        }

      }
    }
  }
}
</style>